module.exports = __webpack_public_path__ + "static/img/5.12c0347.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/14/eng/5.png
// module id = 4WgI
// module chunks = 0